<template>
  <div class="right-menu" v-if="visible">
    <div class="header">
      <div class="text">参考资料</div>
      <img :src="closeIcon" alt="" class="close-icon" @click="onClose" />
    </div>

    <div class="content">
      <div class="content-item" v-for="(item,index) in resourcesList" :key="index" @click="handleClick(item)">
        <div class="title">{{ filterDocTitle(item) }}</div>
        <div class="text">{{ filterDocContent(item) }}</div>
        <div class="info-admin">
          <div class="source">
            <img :src="sourcerIcon1" alt="" class="source-icon" v-if="filterDocName(item.datasetName) == '典型案例'"/>
            <img :src="sourcerIcon2" alt="" class="source-icon" v-if="filterDocName(item.datasetName) == '法律法规'"/>
            <img :src="sourcerIcon3" alt="" class="source-icon" v-if="filterDocName(item.datasetName) == '外部网站'"/>
            <span>{{ filterDocName(item.datasetName) }}</span>
          </div>
          <div class="sort">{{ item.position }}</div>
        </div>
      </div>


    </div>

    <TypicalCases :visible.sync="typicaVisible" :details="typeDetails"></TypicalCases>
    <DrawerDetial :left="left" :id="law_id" :visible.sync="lawVisible"></DrawerDetial>
  </div>
</template>

<script>
import closeIcon from '@/assets/close-icon.png';
import sourcerIcon1 from '@/assets/source-icon-1.png';
import sourcerIcon2 from '@/assets/source-icon-2.png';
import sourcerIcon3 from '@/assets/source-icon-3.png';
import TypicalCases from './components/TypicalCases.vue'
import DrawerDetial from './components/DrawerDetial.vue'
import { lawdDtail } from '@/services/agent'
import { mapState,mapMutations } from 'vuex';
import handle from "ant-design-vue/lib/vc-slider/src/Handle";
export default {
  components: {
    TypicalCases,
    DrawerDetial
  },
  computed: {
    handle() {
      return handle
    },
    ...mapState('resources',['resourcesList']),
    filterDocName(){
      return function (name){
        if(name.includes('法律法规')){
          return '法律法规'
        }
        if(name.includes('典型案例')){
          return '典型案例'
        }
        if(name.includes('外部网站')){
          return '外部网站'
        }
      }
    },
    filterDocTitle(){
      return function (val){
        console.log(val)
        if(val.datasetName.includes('法律法规')){
          return val.datasetName
        }
        if(val.datasetName.includes('典型案例')){
          let content = JSON.parse(val.content)
          return content['标题']
        }
        if(val.datasetName.includes('外部网站')){
          return val.datasetName
        }
      }
    },
    filterDocContent(){
      return function (val){
        if(val.datasetName.includes('法律法规')){
          return val.content
        }
        if(val.datasetName.includes('典型案例')){
          let content = JSON.parse(val.content)
          return content['案情简介']
        }
        if(val.datasetName.includes('外部网站')){
          return val.content
        }
      }
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      closeIcon,
      sourcerIcon1,
      sourcerIcon2,
      sourcerIcon3,
      left:0,
      law_id:'',
      typicaVisible:false,
      lawVisible:false,
      typeDetails:{},
    }
  },
  mounted() {
    if(window.innerWidth < 1220){
      this.left = -50
    }else{
      this.left = 0
    }
  },
  methods:{
    ...mapMutations('resources',['setResourcesList','setShow']),
    async handleClick(val){
      if(val.datasetName.includes('典型案例')){
        this.typeDetails = JSON.parse(val.content)
        this.typicaVisible = true
      }

      if(val.datasetName.includes('法律法规')){
        let res = await lawdDtail(val.documentId)
        if(res.code == 200){
          this.law_id = val.documentId
          this.lawVisible = true
        }
      }

      if(val.datasetName.includes('外部网站')){
        window.open(val.content, '_blank');
      }

    },
    onClose(){
      this.setResourcesList([])
      this.setShow(false)
    }
  },
}
</script>

<style lang="scss" scoped>
.right-menu{
  display: flex;
  flex-direction: column;
  width: 384px;
  height: 100vh;
  border-left: 1px solid rgba(0,0,0,0.1);
  .content-item:hover{
    background: #F0F3F8;
  }
  .content-item{
    .info-admin{
      display: flex;
      justify-content: space-between;
      .source{
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        .source-icon{
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
      .sort{
        padding: 2px 4px;
        background: #FAFAFA;
        border-radius: 4px;
        border: 1px solid #E6E6E6;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
      }
    }
    .text{
      font-size: 14px;
      color: #666666;
      line-height: 20px;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 10px;
    }
    .title{
      font-size: 16px;
      color: #2C2C2C;
      line-height: 22px;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow:ellipsis;
      margin-bottom: 8px;
    }
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 16px;
    cursor: pointer;
  }
  .content{
    flex: 1;
    height: 100px;
    overflow-y: auto;
    padding: 12px;
  }
  /* 隐藏滚动条 */
  .content::-webkit-scrollbar {
    width: 0;
  }
  
  .content::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
  }
  .header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
    background: #FCFCFC;
    .text{
      font-weight: bold;
      font-size: 16px;
      color: rgba(0,0,0,0.85);
      line-height: 24px;
    }
    .close-icon{
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
}
</style>